export default __webpack_public_path__ + "static/media/ihr-klare-seraphim.35264ce9.png";